import script from "./defaultProfileImageDisplayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./defaultProfileImageDisplayer.vue?vue&type=script&setup=true&lang=ts"

import "./defaultProfileImageDisplayer.vue?vue&type=style&index=0&id=a3322fae&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3322fae"]])

export default __exports__